import { ViewportScroller } from '@angular/common';
import { Component, OnInit, afterNextRender, inject, signal } from '@angular/core';
import { impressumHosting, toImpressumOwnerSection, type ImpressumSection } from './impressum.data';
import { SeoService } from '../../services/seo.service';
import { ImpressumService } from '../../services/impressum.service';

@Component({
  selector: 'app-impressum',
  imports: [],
  templateUrl: './impressum.component.html',
  styleUrl: './impressum.component.scss',
})
export class ImpressumComponent implements OnInit {
  private readonly viewport = inject(ViewportScroller);
  private readonly seo = inject(SeoService);
  private readonly impressumService = inject(ImpressumService);

  readonly owner = signal<ImpressumSection | null>(null);
  readonly hosting = impressumHosting;

  constructor() {
    afterNextRender(() => this.viewport.scrollToPosition([0, 0]));
  }

  ngOnInit() {
    this.seo.setPageSeo({
      title: 'Impresszum – Kanyar Büfé Pákozd',
      description:
        'Kanyar Büfé impresszum: az üzemeltető és a tárhelyszolgáltató adatai, kapcsolattartás.',
      canonical: 'https://kanyarbufe.hu/impresszum',
    });

    this.impressumService.getImpressum().subscribe((dto) => {
      this.owner.set(dto ? toImpressumOwnerSection(dto) : null);
    });
  }

  isExternalHttpHref(href: string): boolean {
    return /^https?:\/\//i.test(href);
  }
}
